import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TertiaryButton } from '@dev/ee-components';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { StartEditStep, getFormCreatorStore } from '@/store/formCreator/actions';
import { StepTitleProps } from './types';
import { StepTitleWrapper } from './styles';

export const StepTitle = ({
    title,
    isEditVisible,
    isEditDisabled,
    stepName
}: StepTitleProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { formPayload } = useSelector(getFormCreatorStore);
    const onEditStep = (): void => {
        dispatch(StartEditStep(stepName));
    }
    const onEdit = (): void => {
        if (!formPayload) {
            onEditStep();
            return;
        }

        const dialogParams: ShowDialogParams = {
            title: t('editstep'),
            confirmLabel: t('confirm'),
            body: t('editstepcancelchanges_desc'),
            onClickConfirm: onEditStep,
            cancelLabel: t('cancel'),
        };
        dispatch(ShowDialog(dialogParams));
    };

    return (
        <StepTitleWrapper>
            {title}
            {isEditVisible && <TertiaryButton onClick={onEdit} disabled={isEditDisabled} text={t('edit')} />}
        </StepTitleWrapper>
    );
};
